import { createApp } from 'vue'
import RadianConverter from './RadianConverter.vue'
import './assets/global.css'

createApp(RadianConverter).mount('#radian')
